export const RedirectTo = {
  login: '/',
  activate: '/activate',
  resendCode: '/resendCode',
  forgotPassword: '/forgotPassword',
  resetPassword: '/resetPassword',
  dashboard: '/dashboard',
  parking: '/parking',
  monitors: '/monitors'
}
